{
  "en": {
    "courseCatalog": {
      "activeCourses": {
        "title": "Active Courses",
        "toCourse": "To the Course"
      },
      "headers": {
        "title": "Discover relevant professional development courses",
        "subtitle": "What would you like to learn today?"
      },
      "filters": {
        "courseType": "Course type",
        "subjectAreas": "Subject areas",
        "languages": "Language",
        "order": {
          "label": "Sort by",
          "relevant": "Relevance",
          "mostRecent": "Most recent",
          "rating": "Rating",
          "popular": "Popular"
        }
      },
      "courseTypes": {
        "courses": "Self-study courses",
        "webinar": "Live webinars",
        "recording": "Recordings",
        "impulse": "Micro lessons"
      },
      "sections": {
        "liveWebinars": "Live Webinars",
        "liveWebinarsDescription": "Attend live presentations, participate in discussions, and interact with expert speakers.",
        "newCourses": "New courses",
        "pinned": "Favorites by fobizz",
        "pinnedDescription": "A hand-picked selection of popular courses recommended by the fobizz editorial team.",
        "impulses": "Micro lessons",
        "impulsesDescription": "Explore a variety of relevant and engaging topics in just 30 minutes.",
        "courses": "Self-study Courses",
        "coursesDescription": "Learn at your own pace with video courses focused on practical, applicable skills.",
        "recommendations": "Personalized recommendations",
        "recommendationsDescription": "A curated list of courses relevant for you, based on your profile details and the courses you have already enrolled in or bookmarked.",
        "recordings": "Webinar recordings",
        "recordingsDescription": "Watch recordings of past webinars to revisit content and insights from expert speakers."
      },
      "links": {
        "showAllWebinars": "Show all live webinars",
        "showAllCourses": "Show all self-study courses",
        "showAllImpulses": "Show all micro lessons",
        "showAllRecordings": "Show all webinar recordings"
      },
      "search": {
        "placeholder": "Search courses...",
        "noResults": "Unfortunately, we have not found any courses with these search criteria."
      },
      "subjectAreas": {
        "subject_area_didactic": "Didactics & Instructional Design",
        "subject_area_media_education": "Media Literacy",
        "subject_area_collaboration": "Teamwork & Relationship Building",
        "subject_area_school_development": "School Development & Leadership",
        "subject_area_performance": "Performance, Feedback & Progress",
        "subject_area_diversity": "Inclusion, Differentiation & Language Development",
        "subject_area_health": "Health and Professional Growth",
        "subject_area_ki": "Artificial Intelligence",
        "subject_area_tools": "Digital Tools & Applications",
        "subject_area_kids_world": "Student Perspectives & Society",
        "subject_area_chances": "Startchancen",
        "subject_area_programming": "Programming & Computer Sciences"
      },
      "teaser": {
        "title": "Get individual advice from our course finder.",
        "linkName": "Show AI course guide"
      },
      "languages": {
        "de": "German",
        "en": "English",
        "fr": "French",
        "es": "Spanish"
      }
    }
  }
}
